import { createSelector } from "reselect";

export const getInstanceId = createSelector(
  (state) => state.instance,
  (instance) => {
    if (instance) {
      return Number(instance);
    }
    return null;
  }
);
